const mainNav = document.querySelector("#main-navbar");
const menuBtn = document.querySelector("#mobile-menu-btn");
const subMenu = document.querySelectorAll(".sub-menu");
const overlay = document.querySelector(".overlay-close");
const hasSub = document.querySelectorAll(".has-sub");
const bgOverlay = document.querySelector(".overlay-bg");
const toggleBtn = document.querySelectorAll(".toggle-btn");

const nav = document.getElementById("nav-main");
const closeBtn = document.getElementById("mobile-close-btn");
const hero = document.getElementById("hero");


if (mainNav) {
  toggleBtn.forEach(btn => {
    btn.addEventListener("click", function(e) {
      e.preventDefault();
      this.classList.toggle("open");
      this.previousElementSibling.classList.toggle("open");
    })
  })

  function openMenu() {
    mainNav.classList.add("open");
    overlay.classList.add("open");
    // this.classList.add("open");
    nav.classList.add("hide");
    document.body.classList.add("nav-open");
    if (hero) {
      hero.classList.add("open");
    }
  }
  function closeMenu() {
    mainNav.classList.remove("open");
    menuBtn.classList.remove("open");
    subMenu.forEach(menu => {
      if (menu.classList.contains("open")) {
        menu.classList.remove("open");
      }
    })
    toggleBtn.forEach(btn => {
      if (btn.classList.contains("open")) {
        btn.classList.remove("open");
      }
    })
    overlay.classList.remove("open");
    nav.classList.remove("hide");
    // fix firefox submenu :focus issue
    document.activeElement.blur();
    if (hero) {
      hero.classList.remove("open");
    }
    document.body.classList.remove("nav-open");
  }

  document.addEventListener("keyup", function (e) {
    if (e.key === "Escape") closeMenu();
  });
  document.addEventListener("click", function () {
    if (mainNav.classList.contains("open")) {
      overlay.classList.add("open");
    }
  });

  function desktopBgHover() {
    if (window.innerWidth > 1024) {
      hasSub.forEach(function (item) {
        item.addEventListener("mouseover", function () {
          bgOverlay.classList.add("open");
        });
        item.addEventListener("mouseout", function () {
          bgOverlay.classList.remove("open");
        });
      });
    }
  }
  desktopBgHover();

  const mq = window.matchMedia("screen and (min-width: 1025px)");

  mq.addEventListener("change", event => {
    if (event.matches) {
      desktopBgHover();
      closeMenu();
    }
  })

  menuBtn.addEventListener("click", openMenu);
  overlay.addEventListener("click", closeMenu);
  closeBtn.addEventListener("click", closeMenu);
}
